export default __webpack_public_path__ + "static/media/ic_experience.76e5af03.svg";